export enum BannerNotificationFilter {
  CURRENT = 'CURRENT',
  PAST = 'PAST'
}
